import React from 'react'
import { Button, Row, Modal, notification } from 'antd'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
import StyledInput from '@nexys/components/Input'

import ApiCall from 'services/ApiCall'
import { useMutation, useQueryClient } from 'react-query'
import classNames from '../Header.module.scss'

interface ChangeProfileAttributes {
  id: string
  fullName: string
  email: string
  phone: string
}

export default function ModalEditProfile(props) {
  const { active, setActive, userId, setActiveProfile, profile, setUser, user } = props
  const queryClient = useQueryClient()

  const updateMutation = useMutation((values: ChangeProfileAttributes) => {
    return ApiCall.User.update(values?.id, values)
  },
  {
    onSettled: () => {
      queryClient.invalidateQueries(`/get-users-${userId}`)
    },
  })

  return (
    <Modal
      style={{
        justifyContent: 'center',
        alignItems: 'center'
      }}
      visible={active}
      footer={null}
      onCancel={() => {
        setActiveProfile(true)
        setActive(!active)
      }}
    >
      <Formik
        initialValues={{
          fullName: profile?.fullName || "",
          email: profile?.email || "",
          phone: profile?.phone || ""
        }}
        validationSchema={yup.object().shape({
          fullName: yup.string().required('Nama harus diisi!'),
          email: yup.string().required('Email harus diisi!'),
          phone: yup.string().required('HP harus diisi!'),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true)
          try {
            const res = await updateMutation.mutateAsync({
              ...values,
              id: userId
            })
            localStorage.setItem(
              'full_name',
              values?.fullName,
            )
            setUser({
              ...user,
              fullName : values?.fullName,
            })

            if (res.data.error) {
              notification.error({
                message: res.data.error?.data?.message,
              })
              return
            }

            notification.success({
              message: res.data?.message,
            })
            setActive(!active)
            setActiveProfile(true)
          } catch (error) {
            notification.error({
              message: error.response.data?.message,
            })

            setSubmitting(false)
          } finally {
            setSubmitting(false)
          }
        }}
      >
        {({ handleChange, isSubmitting, values }) => (
          <Form>
            <Row
              align="middle"
              gutter={10}
              justify="center"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <StyledInput
                style={{ width: '100%' }}
                topSpace={10}
                label={'Nama'}
                value={values.fullName}
                id="fullName"
                name="fullName"
                placeholder="Masukkan nama"
                bordered
                required
                handleChange={handleChange}
              />
              <StyledInput
                style={{ width: '100%' }}
                topSpace={10}
                value={values.email}
                label={'Email'}
                placeholder="Masukkan email"
                id="email"
                name="email"
                bordered
                required
                handleChange={handleChange}
              />
              <StyledInput
                style={{ width: '100%' }}
                topSpace={10}
                value={values.phone}
                label={'HP'}
                id="phone"
                name="phone"
                placeholder="Masukkan HP"
                bordered
                required
                handleChange={handleChange}
              />
              <Button
                className={classNames.save}
                disabled={isSubmitting}
                htmlType="submit"
                size="large"
              >
                Simpan
              </Button>
            </Row>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}
